import styles from './MadeIactivePro.module.css';

export const MadeIactivePro = ({}) => {
  return (
    <div className={styles.wrapper}>
      На базе сервиса <span>iactive.pro</span>
    </div>
  );
};
